import { ThemeProvider, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import React from 'react';
import { newVyTheme } from '../../assets/themes/new-vy-theme';
import { useGlobalVariable } from '../../hooks/use-global-variable';
import VyDialog from '../new-design/feedback/VyDialog';

export const SandboxDialog: React.FC = () => {
  const [_showSandboxDialog, setGlobalValue] = useGlobalVariable('showSandboxDialog');

  return (
    <ThemeProvider theme={newVyTheme}>
      <VyDialog
        open
        label={(
          <VyIcon
            icon="Logo"
            color="#3A78F8"
          />
        )}
        ctaText="Contact us"
        onClose={() => setGlobalValue(false)}
      >
        <Typography variant="body1">Saving is not available in this sandbox. Please contact us to get your own environment.</Typography>
      </VyDialog>
    </ThemeProvider>
  );
};